import { render, staticRenderFns } from "./LogoBackground.vue?vue&type=template&id=523f260a&scoped=true"
import script from "./LogoBackground.vue?vue&type=script&lang=js"
export * from "./LogoBackground.vue?vue&type=script&lang=js"
import style0 from "./LogoBackground.vue?vue&type=style&index=0&id=523f260a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f260a",
  null
  
)

export default component.exports